import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { ArrowDropDownRounded, ArrowRightRounded } from "@mui/icons-material";

import { Fieldset } from "./styled/Fieldset";

export function CollapsableFieldset({
    isShown,
    className,
    printLegend,
    dataHook,
    legendText,
    icon,
    renderBeforeChildren,
    children
}) {
    const [expanded, setExpanded] = useState(Boolean(isShown));

    return (
        <Fieldset className={className} data-testid="collapsable-fieldset">
            <legend>
                <FieldTitle
                    noPrint={!printLegend}
                    onClick={() => setExpanded(v => !v)}
                    data-hook={dataHook}
                    data-testid="collapsable-fieldset-label"
                >
                    {expanded ? (
                        <ArrowDropDownRounded
                            color="secondary"
                            aria-hidden="true"
                            id="arrow-indicator"
                        />
                    ) : (
                        <ArrowRightRounded
                            color="secondary"
                            aria-hidden="true"
                            id="arrow-indicator"
                        />
                    )}
                    <span>{legendText}</span>
                    {icon}
                </FieldTitle>
            </legend>
            {renderBeforeChildren ? renderBeforeChildren() : null}
            {expanded && <div data-testid="collapsable-fieldset-content">{children}</div>}
        </Fieldset>
    );
}

export const FieldTitle = styled.div`
    display: flex;
    align-items: center;

    span {
        margin-right: 5px;
    }

    svg {
        margin-bottom: 3px;
    }

    @media print {
        display: ${props => (props.noPrint ? "none" : "initial")};

        svg {
            display: none !important;
        }
    }
`;

CollapsableFieldset.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    className: PropTypes.string,
    dataHook: PropTypes.string,
    isShown: PropTypes.bool,
    legendText: PropTypes.string,
    printLegend: PropTypes.bool,
    renderBeforeChildren: PropTypes.func,
    toggleShow: PropTypes.func,
    icon: PropTypes.node
};
